module.exports = __webpack_public_path__ + "assets/e6a65dd281b6799ea7a2ab3e676d2e53.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/buttons/next.mp3
 ** module id = 327
 ** module chunks = 0
 **/